// Notification.jsx
import React from "react";
import styles from "./notification.module.css";
import { useNavigate } from "react-router-dom";

const Notification = () => {
  return (
    <div className={styles.centerPage}>
      <div className={styles.card}>
        {/* 👇 Add your GIF here */}

        <div className={styles.title}>{"Basic Kyc Done!"}</div>
        <div className={styles.message}>{"Please wait a moment...."}</div>
        <div className={styles.message}>
          {"We are setting up your CUPI dashboard."}
        </div>
        <img
          src="/cupiDog.svg"
          alt="" // decorative; leave empty. Or add real alt text.
          className={styles.illustration}
          loading="eager"
          decoding="async"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
      </div>
    </div>
  );
};

export default Notification;
